﻿import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { Button, ButtonSave } from 'components/buttons';
import { Dialog } from '@blueprintjs/core';
import './Notifications.css';

export function AlertConfirm(
    {
        isOpen = false,
        title = "",
        disabled = false,
        saving = false,
        confirmButtonIntent = "danger",
        confirmButtonText = "Confirm",
        cancelButtonIntent = "secondary",
        cancelButtonText = "Cancel",
        children,
        onCancel,
        onConfirm
    }
) {

    function handleConfirmClick() {
        onConfirm();
    }

    function handleCancelClick() {
        onCancel();
    }

    return (
        <Fragment>
            <Dialog
                isOpen={isOpen}
                title={title}
                isCloseButtonShown={false}
                className='modal-holder alert-confirm small'
            >
                <div className="bp6-dialog-body">
                    {children}
                </div>

                <div className="bp6-dialog-footer">
                    <div className="bp6-dialog-footer-actions">
                        <ButtonSave icon={null} text={confirmButtonText} intent={confirmButtonIntent} onClick={handleConfirmClick} simpleDisabled={disabled} disabled={saving} id="confirm-button" />
                        <Button text={cancelButtonText} intent={cancelButtonIntent} onClick={handleCancelClick} disabled={saving} id="cancel-button"></Button>
                    </div>
                </div>
              
            </Dialog>
        </Fragment>
    );
}

AlertConfirm.propTypes = {
    isOpen: PropTypes.bool,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    title: PropTypes.string,
    disabled: PropTypes.bool,
    confirmButtonIntent: PropTypes.string,
    confirmButtonText: PropTypes.string,
    cancelButtonIntent: PropTypes.string,
    cancelButtonText: PropTypes.string,
    saving: PropTypes.bool,
    children: PropTypes.node
};
